import { isEmpty, isObject } from 'lodash';

export const isEmptyObject = (obj: object): boolean => {
	return (Object.keys(obj) as (keyof typeof obj)[]).every((key) =>
		isObject(obj[key]) ? isEmptyObject(obj[key]) : isEmpty(obj[key]),
	);
};
